import { ReactNode } from "react";
import MuiTypography from "@material-ui/core/Typography";
import styles from "./Label.module.scss";

interface LabelProps {
  children: ReactNode;
  htmlFor?: string;
  className?: string;
}

/**
 * Label component wrapper using Material UI
 */
export const Label = ({ children, htmlFor, className = "" }: LabelProps) => {
  return (
    <MuiTypography
      component="label"
      htmlFor={htmlFor}
      className={`${styles.label} ${className}`}
    >
      {children}
    </MuiTypography>
  );
};
